import { render } from "./Schedule.vue?vue&type=template&id=73a94e47&scoped=true&ts=true"
import script from "./Schedule.vue?vue&type=script&lang=ts"
export * from "./Schedule.vue?vue&type=script&lang=ts"

import "./Schedule.vue?vue&type=style&index=0&id=73a94e47&scoped=true&lang=css"

import exportComponent from "/home/runner/work/studiostvapp/studiostvapp/PlatformStudiosApp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73a94e47"]])

export default __exports__